var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "button-cell",
      attrs: { "data-field-type": "automation-button" },
    },
    [
      _c(
        "a-button",
        {
          attrs: { disabled: _vm.isDisabled, type: "primary" },
          on: {
            click: function ($event) {
              return _vm.$feature.beforeRunButtonAutomation(_vm.handleClick)
            },
          },
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }